var map = {
	"./back_head.svg": 4085,
	"./back_head_active.svg": 78526,
	"./back_left_buttocks.svg": 1956,
	"./back_left_buttocks_active.svg": 48401,
	"./back_left_elbow.svg": 66964,
	"./back_left_elbow_active.svg": 80417,
	"./back_left_foot.svg": 13199,
	"./back_left_foot_active.svg": 17208,
	"./back_left_hand.svg": 86012,
	"./back_left_hand_active.svg": 57145,
	"./back_left_lower_arm.svg": 65777,
	"./back_left_lower_arm_active.svg": 91810,
	"./back_left_lower_back.svg": 13116,
	"./back_left_lower_back_active.svg": 50553,
	"./back_left_lower_leg.svg": 29767,
	"./back_left_lower_leg_active.svg": 78931,
	"./back_left_neck.svg": 52618,
	"./back_left_neck_active.svg": 24711,
	"./back_left_upper_arm.svg": 6850,
	"./back_left_upper_arm_active.svg": 77935,
	"./back_left_upper_back.svg": 42629,
	"./back_left_upper_back_active.svg": 32078,
	"./back_left_upper_leg.svg": 29912,
	"./back_left_upper_leg_active.svg": 65853,
	"./back_lower_body.svg": 28945,
	"./back_lower_body_active.svg": 8322,
	"./back_neck.svg": 51730,
	"./back_neck_active.svg": 7839,
	"./back_right_buttocks.svg": 94389,
	"./back_right_buttocks_active.svg": 67742,
	"./back_right_elbow.svg": 32403,
	"./back_right_elbow_active.svg": 52404,
	"./back_right_foot.svg": 85254,
	"./back_right_foot_active.svg": 25451,
	"./back_right_hand.svg": 81341,
	"./back_right_hand_active.svg": 78102,
	"./back_right_lower_arm.svg": 42878,
	"./back_right_lower_arm_active.svg": 35123,
	"./back_right_lower_back.svg": 98065,
	"./back_right_lower_back_active.svg": 1858,
	"./back_right_lower_leg.svg": 24836,
	"./back_right_lower_leg_active.svg": 85649,
	"./back_right_neck.svg": 3075,
	"./back_right_neck_active.svg": 69956,
	"./back_right_upper_arm.svg": 24857,
	"./back_right_upper_arm_active.svg": 87706,
	"./back_right_upper_back.svg": 63956,
	"./back_right_upper_back_active.svg": 86337,
	"./back_right_upper_leg.svg": 8015,
	"./back_right_upper_leg_active.svg": 88408,
	"./back_upper_body.svg": 98032,
	"./back_upper_body_active.svg": 61701,
	"./front_head.svg": 68615,
	"./front_head_active.svg": 59808,
	"./front_left_foot.svg": 72649,
	"./front_left_foot_active.svg": 93994,
	"./front_left_groin.svg": 82788,
	"./front_left_groin_active.svg": 15249,
	"./front_left_hand.svg": 48806,
	"./front_left_hand_active.svg": 4427,
	"./front_left_knee.svg": 24880,
	"./front_left_knee_active.svg": 66213,
	"./front_left_lower_arm.svg": 77719,
	"./front_left_lower_arm_active.svg": 93616,
	"./front_left_lower_body.svg": 34103,
	"./front_left_lower_body_active.svg": 9360,
	"./front_left_lower_leg.svg": 52333,
	"./front_left_lower_leg_active.svg": 69158,
	"./front_left_upper_arm.svg": 78976,
	"./front_left_upper_arm_active.svg": 32949,
	"./front_left_upper_body.svg": 15694,
	"./front_left_upper_body_active.svg": 43011,
	"./front_left_upper_leg.svg": 11334,
	"./front_left_upper_leg_active.svg": 51691,
	"./front_lower_body.svg": 93795,
	"./front_lower_body_active.svg": 87428,
	"./front_neck.svg": 25296,
	"./front_neck_active.svg": 1381,
	"./front_right_foot.svg": 15400,
	"./front_right_foot_active.svg": 27725,
	"./front_right_groin.svg": 50591,
	"./front_right_groin_active.svg": 54728,
	"./front_right_hand.svg": 63327,
	"./front_right_hand_active.svg": 86600,
	"./front_right_knee.svg": 59409,
	"./front_right_knee_active.svg": 76610,
	"./front_right_lower_arm.svg": 39612,
	"./front_right_lower_arm_active.svg": 80185,
	"./front_right_lower_body.svg": 34218,
	"./front_right_lower_body_active.svg": 45415,
	"./front_right_lower_leg.svg": 65586,
	"./front_right_lower_leg_active.svg": 53599,
	"./front_right_upper_arm.svg": 20751,
	"./front_right_upper_arm_active.svg": 50136,
	"./front_right_upper_body.svg": 10319,
	"./front_right_upper_body_active.svg": 29944,
	"./front_right_upper_leg.svg": 59461,
	"./front_right_upper_leg_active.svg": 57121,
	"./front_upper_body.svg": 92666,
	"./front_upper_body_active.svg": 78999,
	"./line.svg": 47043
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10877;